import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

export const CriyaShortDarkLogoSvg = () => (
  <svg width='24' height='28' viewBox='0 0 24 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M19.2114 18.8652C21.8562 18.8652 24.0003 21.0093 24.0003 23.6541C24.0003 26.0543 22.0546 28 19.6544 28L19.0457 28C16.0303 28 13.5859 25.5556 13.5859 22.5403L13.5859 18.8652L19.2114 18.8652Z'
      fill='url(#paint0_linear_6001_33788)'
    />
    <path
      d='M12.4111 4.71688C12.4111 2.11182 10.2993 0 7.69425 0H6.57621C2.94429 0 3.91006e-05 2.94425 3.91006e-05 6.57618C3.91006e-05 9.76595 2.58586 12.3518 5.77564 12.3518H12.4111V4.71688Z'
      fill='url(#paint1_linear_6001_33788)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.71452 13.543H12.4111V22.5586C12.4111 25.5636 10.0096 27.9997 7.04731 27.9997H1.87928C0.841383 27.9997 0 27.1462 0 26.0933V20.3543C0 16.5925 3.00619 13.543 6.71452 13.543ZM1.16801 20.8193C1.52594 18.5342 3.02431 16.228 5.73577 15.6355C5.82604 15.6158 5.74088 15.6707 5.53725 15.802C4.75294 16.3078 2.21119 17.947 1.16801 20.8193Z'
      fill='url(#paint2_linear_6001_33788)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.7931 0C15.9173 0 13.5859 2.36495 13.5859 5.28227V17.6738H20.9073C22.6155 17.6738 24.0003 16.269 24.0003 14.5362V5.28227C24.0003 2.36495 21.669 0 18.7931 0ZM15.2304 7.8601C15.2649 5.04237 15.3 2.17272 18.5007 1.10019C15.7355 2.51478 15.448 6.29377 15.2888 8.38733C15.2575 8.79885 15.2311 9.14526 15.1919 9.39578C15.2178 8.89327 15.2241 8.37756 15.2304 7.8601Z'
      fill='url(#paint3_linear_6001_33788)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_6001_33788'
        x1='9.3665'
        y1='17.7491'
        x2='9.41484'
        y2='24.0502'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#A98273' />
        <stop offset='0.520833' stopColor='#C6978C' />
        <stop offset='1' stopColor='#D8B8AB' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_6001_33788'
        x1='14.0165'
        y1='4.2858'
        x2='5.84634'
        y2='-1.31002'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#819585' />
        <stop offset='0.396113' stopColor='#91A999' />
        <stop offset='1' stopColor='#ADC8B6' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_6001_33788'
        x1='10.865'
        y1='10.7969'
        x2='16.1302'
        y2='26.4271'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#C1BDB4' />
        <stop offset='0.396113' stopColor='#DED6C7' />
        <stop offset='1' stopColor='#F5F3EE' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_6001_33788'
        x1='12.2389'
        y1='6.13241'
        x2='20.9114'
        y2='2.64899'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#D58405' />
        <stop offset='0.396113' stopColor='#F39C12' />
        <stop offset='1' stopColor='#EEB457' />
      </linearGradient>
    </defs>
  </svg>
);

export const CriyaShortDarkLogo = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CriyaShortDarkLogoSvg} {...props} />
);
